import CourseDetail from './CourseDetail.vue';
import { VueAppManager } from '@utils/vueAppManager.js';

export const mountCourseDetail = (elementId = 'app') => {
  return VueAppManager.mountApp(CourseDetail, elementId);
};
